// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-products-container {
  display: flex;
  flex-flow: column;
  align-content: flex-start;
  background-color: var(--ods-color-white);
  border: 1px solid var(--ods-color-gray-20);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(44, 44, 84, 0.07);
  padding: 1.5rem;
  margin-bottom: 1.25rem;
}
.plan-products-container .plan-products-container__header {
  margin-left: 0;
  margin-top: 0;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 700;
  font-size: 1.125rem;
  border-bottom: 2px solid var(--ods-color-purple-30);
}
.plan-products-container .edit-link {
  margin-right: 0.625rem;
  float: right;
}
.plan-products-container .field-name {
  font-weight: 700;
  padding-right: 0.625rem;
}
.plan-products-container .plan-products-inner {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem 1.5rem;
  margin-top: 1rem;
}
@media print {
  .plan-products-container .plan-products-inner {
    font-size: 0.75rem;
  }
}
.plan-products-container .plan-products-inner .plan-products-inner__row {
  display: contents;
}
@media print {
  .plan-products-container .plan-products-inner .plan-products-inner__row {
    margin-right: 2.0625rem;
  }
}
.plan-products-container .plan-products-inner .plan-products-inner__row .products_item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-self: start;
}
.plan-products-container .plan-products-inner .plan-products-inner__row .products_item .field-name {
  display: flex;
  align-items: center;
  gap: 0.125rem;
  line-height: 1.5;
  min-height: 1.5rem;
}
.plan-products-container .plan-products-inner .plan-products-inner__row .products_item .field-value {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.plan-products-container .plan-products-inner .plan-products-inner__row a.edit-pa {
  display: inline-flex;
  align-items: center;
  margin-left: 0;
}
.plan-products-container .plan-products-inner .plan-products-inner__row a.edit-pa img {
  width: 1rem;
  height: 1rem;
}
.plan-products-container .plan-products-inner .plan-products-inner__row .plan-products-inner__edit-item {
  padding: 0.625rem;
}
.plan-products-container .plan-products-inner .plan-products-inner__row .pad-ctrl {
  margin-top: 0.3125rem;
}
.plan-products-container .plan-products-inner .plan-products-inner__row .pad-ctrl ods-radio-group ::ng-deep .ods-radio-group__label {
  display: none;
}
.plan-products-container .plan-products-inner .plan-products-inner__row .pad-ctrl ods-radio-group ::ng-deep .ods-radio-group__fieldset {
  display: flex;
  gap: 1rem;
}
.plan-products-container .plan-products-inner .plan-products-inner__row .pad-ctrl ods-radio-group ::ng-deep[orientation=horizontal] .ods-radio-group__fieldset {
  flex-direction: row;
}
.plan-products-container .plan-products-inner .plan-products-inner__row ods-tooltip ::ng-deep [slot=content] {
  font-weight: normal;
}
.plan-products-container .plan-products-inner .plan-products-inner__row .radio-grps {
  margin-left: 30%;
}
.plan-products-container .buttons-container {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
.plan-products-container .submit-btn {
  width: 18.75rem;
}

.hipaa-edit-container {
  display: flex;
  flex-flow: row;
}
.hipaa-edit-container div:first-child {
  width: 6.5625rem;
  white-space: normal;
  margin-right: 0.625rem;
}
.hipaa-edit-container div:first-child > p {
  margin-left: 15%;
}
.hipaa-edit-container div:last-child {
  width: 8.75rem;
  white-space: normal;
  margin-right: 0.625rem;
}
.hipaa-edit-container div:last-child > p {
  margin-left: 12%;
}

orchid-tooltip {
  margin-left: 1.25rem;
}

ods-tooltip {
  display: inline-flex;
  margin-left: 0.375rem;
  vertical-align: middle;
}

.wrapword {
  /* stylelint-disable */
  white-space: -moz-pre-wrap !important;
  /* Mozilla, since 1999 */
  white-space: -pre-wrap;
  /* Opera 4-6 */
  white-space: -o-pre-wrap;
  /* Opera 7 */
  white-space: pre-wrap;
  /* css-3 */
  word-wrap: break-word;
  /* Internet Explorer 5.5+ */
  white-space: -webkit-pre-wrap;
  /* Newer versions of Chrome/Safari*/
  word-break: break-all;
  white-space: normal;
  /* stylelint-enable */
}

@media print {
  .no-print {
    display: none !important;
  }
  body {
    -webkit-print-color-adjust: exact;
  }
  ods-icon {
    display: none !important;
  }
  .edit-link {
    display: none !important;
  }
  .plan-products-container {
    padding: 0.75rem !important;
    margin-bottom: 0.5rem !important;
  }
  .plan-products-container__header {
    font-size: 11pt !important;
    margin-bottom: 0.5rem !important;
    padding-bottom: 0.25rem !important;
  }
  .plan-products-inner {
    gap: 0.5rem 1rem !important;
    margin-top: 0.5rem !important;
    font-size: 10pt;
  }
  .products_item {
    gap: 0.25rem !important;
  }
  .field-name {
    font-size: 10pt !important;
    min-height: auto !important;
  }
  .field-value {
    font-size: 10pt !important;
  }
}
.warning-strip {
  text-align: right;
}
.warning-strip .warning-message {
  color: var(--ods-color-red-60);
  font-weight: 600;
  margin-left: 6.25rem;
}

.cobra-popup-content {
  padding: 1.5rem;
  text-align: center;
}
.cobra-popup-content p {
  margin-bottom: 1.5rem;
  font-size: 1rem;
}
.cobra-popup-content .popup-buttons {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/renewals/planAdminProduct-panel/plan-admin-product-panel.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,wCAAA;EACA,0CAAA;EACA,kBAAA;EACA,4CAAA;EACA,eAAA;EACA,sBAAA;AACF;AACE;EACE,cAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mDAAA;AACJ;AAEE;EACE,sBAAA;EACA,YAAA;AAAJ;AAGE;EACE,gBAAA;EACA,uBAAA;AADJ;AAIE;EACE,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;AAII;EANF;IAOI,kBAAA;EADJ;AACF;AAGI;EACE,iBAAA;AADN;AAGM;EAHF;IAII,uBAAA;EAAN;AACF;AAEM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;AAAR;AAEQ;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAAV;AAGQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AADV;AAKM;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;AAHR;AAKQ;EACE,WAAA;EACA,YAAA;AAHV;AAOM;EACE,iBAAA;AALR;AAQM;EACE,qBAAA;AANR;AAUY;EACE,aAAA;AARd;AAWY;EACE,aAAA;EACA,SAAA;AATd;AAcc;EACE,mBAAA;AAZhB;AAqBU;EACE,mBAAA;AAnBZ;AAwBM;EACE,gBAAA;AAtBR;AA2BE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAzBJ;AA4BE;EACE,eAAA;AA1BJ;;AA8BA;EACE,aAAA;EACA,cAAA;AA3BF;AA6BE;EACE,gBAAA;EACA,mBAAA;EACA,sBAAA;AA3BJ;AA6BI;EACE,gBAAA;AA3BN;AA+BE;EACE,cAAA;EACA,mBAAA;EACA,sBAAA;AA7BJ;AA+BI;EACE,gBAAA;AA7BN;;AAkCA;EACE,oBAAA;AA/BF;;AAkCA;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;AA/BF;;AAkCA;EACE,sBAAA;EACA,qCAAA;EACA,wBAAA;EACA,sBAAA;EACA,cAAA;EACA,wBAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,qBAAA;EACA,2BAAA;EACA,6BAAA;EACA,mCAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;AA/BF;;AAkCA;EACE;IACE,wBAAA;EA/BF;EAkCA;IACE,iCAAA;EAhCF;EAmCA;IACE,wBAAA;EAjCF;EAoCA;IACE,wBAAA;EAlCF;EAqCA;IACE,2BAAA;IACA,gCAAA;EAnCF;EAsCA;IACE,0BAAA;IACA,gCAAA;IACA,kCAAA;EApCF;EAuCA;IACE,2BAAA;IACA,6BAAA;IACA,eAAA;EArCF;EAwCA;IACE,uBAAA;EAtCF;EAyCA;IACE,0BAAA;IACA,2BAAA;EAvCF;EA0CA;IACE,0BAAA;EAxCF;AACF;AA2CA;EACE,iBAAA;AAzCF;AA2CE;EACE,8BAAA;EACA,gBAAA;EACA,oBAAA;AAzCJ;;AA6CA;EACE,eAAA;EACA,kBAAA;AA1CF;AA4CE;EACE,qBAAA;EACA,eAAA;AA1CJ;AA6CE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AA3CJ","sourcesContent":[".plan-products-container {\n  display: flex;\n  flex-flow: column;\n  align-content: flex-start;\n  background-color: var(--ods-color-white);\n  border: 1px solid var(--ods-color-gray-20);\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(44, 44, 84, 0.07);\n  padding: 1.5rem;\n  margin-bottom: 1.25rem;\n\n  .plan-products-container__header {\n    margin-left: 0;\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n    padding-bottom: 0.5rem;\n    font-weight: 700;\n    font-size: 1.125rem;\n    border-bottom: 2px solid var(--ods-color-purple-30);\n  }\n\n  .edit-link {\n    margin-right: 0.625rem;\n    float: right;\n  }\n\n  .field-name {\n    font-weight: 700;\n    padding-right: 0.625rem;\n  }\n\n  .plan-products-inner {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1rem 1.5rem;\n    margin-top: 1rem;\n\n    @media print {\n      font-size: 0.75rem;\n    }\n\n    .plan-products-inner__row {\n      display: contents;\n\n      @media print {\n        margin-right: 2.0625rem;\n      }\n\n      .products_item {\n        display: flex;\n        flex-direction: column;\n        gap: 0.25rem;\n        align-self: start;\n\n        .field-name {\n          display: flex;\n          align-items: center;\n          gap: 0.125rem;\n          line-height: 1.5;\n          min-height: 1.5rem;\n        }\n\n        .field-value {\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n        }\n      }\n\n      a.edit-pa {\n        display: inline-flex;\n        align-items: center;\n        margin-left: 0;\n\n        img {\n          width: 1rem;\n          height: 1rem;\n        }\n      }\n\n      .plan-products-inner__edit-item {\n        padding: 0.625rem;\n      }\n\n      .pad-ctrl {\n        margin-top: 0.3125rem;\n\n        ods-radio-group {\n          ::ng-deep {\n            .ods-radio-group__label {\n              display: none;\n            }\n\n            .ods-radio-group__fieldset {\n              display: flex;\n              gap: 1rem;\n            }\n\n            // For horizontal orientation\n            &[orientation=\"horizontal\"] {\n              .ods-radio-group__fieldset {\n                flex-direction: row;\n              }\n            }\n          }\n        }\n      }\n\n      ods-tooltip {\n        ::ng-deep {\n          [slot=\"content\"] {\n            font-weight: normal;\n          }\n        }\n      }\n\n      .radio-grps {\n        margin-left: 30%;\n      }\n    }\n  }\n\n  .buttons-container {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n  }\n\n  .submit-btn {\n    width: 18.75rem;\n  }\n}\n\n.hipaa-edit-container {\n  display: flex;\n  flex-flow: row;\n\n  div:first-child {\n    width: 6.5625rem;\n    white-space: normal;\n    margin-right: 0.625rem;\n\n    > p {\n      margin-left: 15%;\n    }\n  }\n\n  div:last-child {\n    width: 8.75rem;\n    white-space: normal;\n    margin-right: 0.625rem;\n\n    > p {\n      margin-left: 12%;\n    }\n  }\n}\n\norchid-tooltip {\n  margin-left: 1.25rem;\n}\n\nods-tooltip {\n  display: inline-flex;\n  margin-left: 0.375rem;\n  vertical-align: middle;\n}\n\n.wrapword {\n  /* stylelint-disable */\n  white-space: -moz-pre-wrap !important;\n  /* Mozilla, since 1999 */\n  white-space: -pre-wrap;\n  /* Opera 4-6 */\n  white-space: -o-pre-wrap;\n  /* Opera 7 */\n  white-space: pre-wrap;\n  /* css-3 */\n  word-wrap: break-word;\n  /* Internet Explorer 5.5+ */\n  white-space: -webkit-pre-wrap;\n  /* Newer versions of Chrome/Safari*/\n  word-break: break-all;\n  white-space: normal;\n  /* stylelint-enable */\n}\n\n@media print {\n  .no-print {\n    display: none !important;\n  }\n\n  body {\n    -webkit-print-color-adjust: exact;\n  }\n\n  ods-icon {\n    display: none !important;\n  }\n\n  .edit-link {\n    display: none !important;\n  }\n\n  .plan-products-container {\n    padding: 0.75rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .plan-products-container__header {\n    font-size: 11pt !important;\n    margin-bottom: 0.5rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .plan-products-inner {\n    gap: 0.5rem 1rem !important;\n    margin-top: 0.5rem !important;\n    font-size: 10pt;\n  }\n\n  .products_item {\n    gap: 0.25rem !important;\n  }\n\n  .field-name {\n    font-size: 10pt !important;\n    min-height: auto !important;\n  }\n\n  .field-value {\n    font-size: 10pt !important;\n  }\n}\n\n.warning-strip {\n  text-align: right;\n\n  .warning-message {\n    color: var(--ods-color-red-60);\n    font-weight: 600;\n    margin-left: 6.25rem;\n  }\n}\n\n.cobra-popup-content {\n  padding: 1.5rem;\n  text-align: center;\n\n  p {\n    margin-bottom: 1.5rem;\n    font-size: 1rem;\n  }\n\n  .popup-buttons {\n    display: flex;\n    justify-content: center;\n    margin-top: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
